import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import ServicesSlider from "@/pages/services/components/ServicesSlider";
import ServiceCards from "@/components/feature/ServiceCards";

const COMPANY_NAME = "NetBasis International";

const texts = {
  title: "Nos Services",
  h1Text:
    "Des services commerciaux et techniques complets pour le succès durable de votre entreprise. En tant que partenaire local expérimenté, nous accompagnons les fabricants étrangers de TIC dans le développement de nouveaux marchés et offrons des solutions sur mesure pour chaque étape de votre expansion.",
  introParagraphs: [
    "Chez NetBasis International, nous proposons aux fabricants étrangers du secteur des télécommunications et de l'informatique un large éventail de services commerciaux et techniques, ainsi que du conseil et de la formation, afin de les soutenir rapidement et efficacement dans leur démarche vers de nouveaux marchés. Notre objectif clair est d'atteindre vos objectifs de croissance dans l'ensemble de l'espace économique germanophone (région DACH).",
    "Afin que vous puissiez trouver plus rapidement le domaine d'expertise souhaité, nous avons divisé notre offre en quatre sections spécialisées :",
    "Si vous souhaitez nous impliquer activement dans votre nouvelle activité et nous confier la réalisation de tâches concrètes, consultez la section « Business Development » pour découvrir nos différents services et choisir ce que nous pouvons faire précisément pour vous. Si vous préférez nous avoir à vos côtés en tant que purs conseillers, orientez-vous vers « Consulting ». Si vous désirez nous engager « pour une durée déterminée » dans l'un de nos domaines de spécialité, cliquez simplement sur « Interim Management ». Ou si vous souhaitez faire appel à notre savoir-faire à des fins exclusives de formation et de coaching, rendez-vous dans la section correspondante.",
  ],
  sectionTitle:
    "Ensemble vers l'excellence opérationnelle et un succès commercial durable",
  belowText:
    "Quelle que soit votre idée, NetBasis International vous aide à spécifier précisément les objectifs et les visions de votre plan d'entrée sur le marché. En tant qu'experts sectoriels sur place, nous vous assistons pour examiner en permanence tous les processus et les adapter de manière agile aux exigences individuelles des nouveaux marchés. À cet égard, nous ne nous considérons pas comme un prestataire de services externe, mais comme des collaborateurs loyaux et pleinement intégrés à votre propre équipe, étroitement liés à votre projet. Nous possédons l'intuition fine et l'expertise approfondie des mécanismes du marché local qui sont absolument indispensables pour faire de votre projet à l'étranger un succès réel et durable. Grâce à cet engagement profond et à notre orientation claire vers des résultats mesurables, nous consolidons pas à pas votre présence forte et hautement compétitive sur le marché.",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

const cardTexts = {
  titles: [
    "Développement commercial",
    "Conseil",
    "Management de transition",
    "Formation et coaching",
  ],
  descriptions: [
    "Vous cherchez de l'aide et souhaitez simplement déléguer votre gestion ? Choisissez nos services.",
    "Vous souhaitez nous avoir à vos côtés comme simples conseillers ? Alors découvrez notre portefeuille de prestations.",
    "Vous voulez nos services « à temps partiel » dans l'un de nos domaines ? Alors découvrez tous les détails ici.",
    "Vous aimeriez solliciter notre savoir-faire à des fins de formation et/ou de coaching ? Alors regardez ici.",
  ],
  readMore: "En savoir plus",
};

const renderWithBold = (text: string) => {
  const parts = text ? text.split(COMPANY_NAME) : [];
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < parts.length - 1 && (
        <strong className="text-primary-600">{COMPANY_NAME}</strong>
      )}
    </span>
  ));
};

export default function ServicesFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Nos Services | NetBasis International"
        description="Services commerciaux et techniques complets, conseil et formation pour votre expansion réussie sur le marché DACH."
        ogUrl="https://net-basis.net/fr/services"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <ServicesSlider />

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            {/* WIDGET 1 - Titre (h2) */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {texts.title}
            </h2>

            {/* WIDGET 2 - H1 : texte d'introduction en gras */}
            <h1 className="text-foreground-950 font-semibold text-sm md:text-base leading-relaxed mb-4">
              {texts.h1Text}
            </h1>

            {/* WIDGET 3 - texte normal */}
            <div className="space-y-4 font-body text-sm md:text-base text-foreground-950 leading-relaxed">
              {texts.introParagraphs.map(
                (text, idx) =>
                  text && (
                    <p key={idx}>{renderWithBold(text)}</p>
                  )
              )}
            </div>
          </div>
        </section>

        {/* Service Cards */}
        <ServiceCards
          namespace="services"
          titleKeys={[]}
          descriptionKeys={[]}
          readMoreKey=""
          texts={cardTexts}
        />

        {/* WIDGET 4 + 5 - h2 vert + paragraphe */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {texts.sectionTitle}
            </h2>
            <div className="space-y-4 font-body text-sm md:text-base text-foreground-950 leading-relaxed">
              <p>{renderWithBold(texts.belowText)}</p>
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {texts.claim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}